<template>
  <div>
    <h2>Задачи</h2>

    <!-- add button -->
    <b-row class="mt-5 mb-2">
      <b-col>
        <b-button variant="primary" class="mb-1 mr-1" :to="{ name: 'Tasks'}">
          <b-icon-table></b-icon-table>
        </b-button>

        <b-button class="mb-1" v-on:click="onCreateButton">Добавить</b-button>

        <task-modal :form="form" :isUpdate="isUpdate" @refresh="fetchTasks"></task-modal>
      </b-col>
    </b-row>

    <!-- Фильтр -->
    <b-card class="bg-light mb-3">
      <b-form size="sm">
        <b-form-row>
          <b-col>
            <b-form-group label="Ответственный:" label-size="sm">
              <multi-select
                v-model="taskFilter.responsible"
                :options="optionsResponsible"
                :searchable="true"
                :loading="isLoadingResponsible"
                :internal-search="false"
                :hide-selected="true"
                track-by="last_name"
                label="last_name"
                placeholder="Введите имя для поиска"
                selectLabel="Enter чтобы выбрать"
                :multiple="false"
                :allowEmpty="true"
                @search-change="asyncFindResponsible"
              >
                <template slot="option" slot-scope="props">{{ contactFullName(props.option) }}</template>
                <template slot="noOptions">Начните вводить имя</template>
                <template slot="singleLabel" slot-scope="{ option }">{{ contactFullName(option) }}</template>
                <span slot="noResult">Не найдено</span>
                <template slot="beforeList">
                  <b-button v-if="taskFilter.responsible" block @click="taskFilter.responsible = ''" class="rounded-0">
                    Очистить
                  </b-button>
                </template>
              </multi-select>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <b-button type="button" @click="initFilterData" size="sm">Сбросить фильтр</b-button>
          </b-col>
        </b-form-row>
      </b-form>
    </b-card>

    <!-- week -->
    <div class="board">
      <table class="table table-bordered table-sm">
        <thead>
        <tr>
          <th>–</th>
          <th v-for="(item, date) in weekDays"
              :key="date"
          >
            <div>{{ date }}</div>
            <div><small>Задач: {{ item.total }} шт.</small></div>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <th>Весь день</th>
          <td v-for="(item, date) in weekDays"
              :key="date"
              style="width: 212px"
          >
            <template v-for="task in item.tasks">
              <div v-if="task.dueHour === 23"
                :key="task.id"
                class="draggable-card"
              >
                <TaskCard :task="task" @showTarget="show"/>
              </div>
            </template>
          </td>
        </tr>
        <tr v-for="hour in 24" :key="hour">
          <th v-if="hour <= 10">{{ `0${hour - 1}:00` }}</th>
          <th v-else>{{ `${hour - 1}:00` }}</th>
          <td v-for="(item, date) in weekDays"
              :key="date"
          >
            <template v-for="task in item.tasks">
              <div v-if="task.dueHour === (hour - 1)"
                   :key="task.id"
                   class="draggable-card"
              >
                <TaskCard :task="task" @showTarget="show"/>
              </div>
            </template>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>
<script>
import TaskModal from "../components/TaskModal";
import TaskCard from "../components/TaskCard";
//import {VueDraggableDirective} from 'vue-draggable';
import MultiSelect from 'vue-multiselect';
import commonMixin from '../mixins/common';
import 'vue2-datepicker/index.css';

export default {
  name: "TasksWeek",
  mixins: [commonMixin],
  components: {TaskModal, TaskCard, MultiSelect},
  //directives: {
  //  dragAndDrop: VueDraggableDirective
  //},
  data() {
    return {
      options: {
        dropzoneSelector: 'div.column',
        draggableSelector: '.draggable-card',
        showDropzoneAreas: false,
        multipleDropzonesItemsDraggingEnabled: true,
      },
      page: 1,
      weekDays: {},
      tasks: [],
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      searchQuery: {
        query: '',
        tags: []
      },
      isUpdate: false,
      isBusy: false,
      isBusyButton: false,
      isLoading: false,
      isLoadingDeal: false,
      isLoadingResponsible: false,
      isLoadingContact: false,
      isLoadingCompany: false,
      errorResult: null,
      messageResult: '',
      error: false,
      message: '',
      optionsResponsible: [],
      form: {
        due_date: '',
        content: '',
        responsible: null,
        company: null,
        deal: null,
        contact: null,
        source: null,
        id: null,
        status: 'todo'
      },
      taskFilter: {
        query: '',
        responsible: '',
        status: ''
      },
    }
  },
  created() {
    if (localStorage.getItem('taskFilterLocal')) {
      try {
        this.taskFilter = JSON.parse(localStorage.getItem('taskFilterLocal'));
      } catch (e) {
        console.error(e)
        this.taskFilter.query = ''
        this.taskFilter.responsible = ''
      }
    }
  },
  mounted() {
    let id = this.$route.hash.replace(/^#+/g, '');
    if (id) {
      this.show(id);
    }
    this.fetchTasks();
  },
  watch: {
    'taskFilter': {
      handler: function (data) {
        if (data) {
          localStorage.setItem('taskFilterLocal', JSON.stringify(data));
          this.fetchTasks();
        }
      },
      immediate: false,
      deep: true
    },
  },
  methods: {
    initFilterData() {
      this.taskFilter.query = ''
      this.taskFilter.responsible = ''
    },
    fetchTasks() {
      if (!this.loading)
        this.loading = true;
      this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/tasks/inweek', {
        params: {
          query: this.taskFilter.query,
          responsible: this.taskFilter.responsible.id,
        }
      })
        .then(response => {
          this.weekDays = response.data.weekDays;
        })
        .catch((error) => {
          this.weekDays = {};
          console.error(error);
        })
        .finally(() => this.loading = false);
    },
    onCreateButton() {
      this.form.due_date = '';
      this.form.content = '';
      this.form.responsible = null;
      this.form.company = null;
      this.form.deal = null;
      this.form.contact = null;
      this.form.source = null;
      this.form.id = null;
      this.form.status = 'todo';
      this.isUpdate = false;

      this.$bvModal.show('task-modal');
    },
    show(id) {
      this.isUpdate = true;
      this.error = false;
      this.form.id = id;
      this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/tasks/' + id, {})
        .then((response) => {
          if (response) {
            if (response.data.error === false) {
              this.error = false;
              this.form = response.data.task;
              this.$bvModal.show('task-modal');
            } else {
              console.log(response.data.message);
            }
          }
        });
    },
    asyncFindResponsible(query) {
      this.isLoadingResponsible = true
      const promise = this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/users/?query=' + query);
      return promise.then(response => {
        this.optionsResponsible = response.data.users;
        this.isLoadingResponsible = false;
      }).catch((error) => {
        console.log(error);
        this.optionsResponsible = [];
        this.isLoadingResponsible = false;
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.hidden-overflow {
  overflow: hidden;
  white-space: pre-wrap;
}

.board {
  display: flex;
  flex-flow: row nowrap;
  max-width: calc(100vw - 200px);
}

.task-card {
  width: 210px;
}

.draggable-card {
  margin-bottom: 5px;
  padding: 0.2em 0.4em;
  border-radius: 0.2em;
  line-height: 1.3;

  &:hover {
    .task-card {
      box-shadow: 0 0 0 2px #68b, inset 0 0 0 1px #ddd;
    }
  }

  &:focus {
    outline: none;

    .task-card {
      outline: none;
      box-shadow: 0 0 0 2px #68b, inset 0 0 0 1px #ddd;
    }
  }
}
</style>
